import { RiDraftLine } from "react-icons/ri";
import { cn } from "../../lib/utils";

interface DraftBadgeProps {
  variant?: "default" | "small";
  className?: string;
}

export default function DraftBadge({
  variant = "default",
  className,
}: DraftBadgeProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-1 text-yellow-500 bg-yellow-500/10 rounded-full select-none",
        variant === "default" && "px-3 py-1 text-xs",
        variant === "small" && "px-2 py-0.5 text-xs",
        className
      )}
    >
      <RiDraftLine className="w-3 h-3" />
      <span>Brouillon</span>
    </div>
  );
}
